import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Add a request interceptor
instance.interceptors.request.use(
    (config) => {
        // Log detailed request information
        console.log('Request URL:', config.url);
        console.log('Request method:', config.method);
        console.log('Request headers:', config.headers);
        console.log('With credentials:', config.withCredentials);
        
        // Ensure credentials are included
        config.withCredentials = true;
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
instance.interceptors.response.use(
    (response) => {
        // Log response headers to see if cookies are being set
        console.log('Response headers:', response.headers);
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default instance; 